var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import getMessage from 'src/background/utils/i18n.utils';
import { PrivateKeyType, } from '@interfaces/keys.interface';
import { addCaptionToLoading, addToLoadingList, removeFromLoadingList, } from '@popup/multichain/actions/loading.actions';
import { setErrorMessage, setSuccessMessage, } from '@popup/multichain/actions/message.actions';
import { closeModal, openModal } from '@popup/multichain/actions/modal.actions';
import { refreshActiveAccount } from '@popup/steem/actions/active-account.actions';
import AccountUtils from '@popup/steem/utils/account.utils';
import BlockchainTransactionUtils from '@popup/steem/utils/blockchain.utils';
import { KeysUtils } from '@popup/steem/utils/keys.utils';
import { replaceOldDomains } from '@popup/steem/utils/link';
import { MultisigUtils } from '@popup/steem/utils/multisig.utils';
import ProxyUtils from '@popup/steem/utils/proxy.utils';
import WitnessUtils from '@popup/steem/utils/witness.utils';
import { KeychainKeyTypes, KeychainKeyTypesLC, } from '@steempro/steem-keychain-commons';
import FlatList from 'flatlist-react';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import 'react-tabs/style/react-tabs.scss';
import { CheckboxPanelComponent } from 'src/common-ui/checkbox/checkbox-panel/checkbox-panel.component';
import { SVGIcons } from 'src/common-ui/icons.enum';
import { InputType } from 'src/common-ui/input/input-type.enum';
import InputComponent from 'src/common-ui/input/input.component';
import { MetadataPopup } from 'src/common-ui/metadata-popup/metadata-popup.component';
import { SVGIcon } from 'src/common-ui/svg-icon/svg-icon.component';
import { AsyncUtils } from 'src/utils/async.utils';
import * as ValidUrl from 'valid-url';
const MAX_WITNESS_VOTE = 30;
const WitnessTab = ({ ranking, hasError, activeAccount, addToLoadingList, removeFromLoadingList, setErrorMessage, setSuccessMessage, refreshActiveAccount, addCaptionToLoading, openModal, closeModal, }) => {
    const [displayVotedOnly, setDisplayVotedOnly] = useState(false);
    const [hideNonActive, setHideNonActive] = useState(true);
    const [remainingVotes, setRemainingVotes] = useState('...');
    const [filteredRanking, setFilteredRanking] = useState([]);
    const [filterValue, setFilterValue] = useState('');
    const [votedWitnesses, setVotedWitnesses] = useState([]);
    const [usingProxy, setUsingProxy] = useState(false);
    const [keyType, setKeyType] = useState();
    useEffect(() => {
        init();
    }, []);
    useEffect(() => {
        if (activeAccount) {
            setKeyType(KeysUtils.getKeyType(activeAccount.keys.active, activeAccount.keys.activePubkey, activeAccount.account, activeAccount.account, KeychainKeyTypesLC.active));
        }
    }, [activeAccount]);
    const init = () => __awaiter(void 0, void 0, void 0, function* () {
        setRemainingVotes(MAX_WITNESS_VOTE - activeAccount.account.witnesses_voted_for);
        let proxy = yield ProxyUtils.findUserProxy(activeAccount.account);
        setUsingProxy(proxy !== null);
        if (proxy) {
            initProxyVotes(proxy);
        }
        else {
            setVotedWitnesses(activeAccount.account.witness_votes);
        }
    });
    useEffect(() => {
        setVotedWitnesses(activeAccount.account.witness_votes);
        setRemainingVotes(MAX_WITNESS_VOTE - activeAccount.account.witnesses_voted_for);
    }, [activeAccount]);
    useEffect(() => {
        if (ranking)
            setFilteredRanking(ranking.filter((witness) => witness.owner.toLowerCase().includes(filterValue.toLowerCase()) &&
                (!displayVotedOnly || votedWitnesses.includes(witness.owner)) &&
                (!hideNonActive ||
                    witness.signing_key !==
                        'STM1111111111111111111111111111111114T1Anm')));
    }, [ranking, filterValue, displayVotedOnly, votedWitnesses, hideNonActive]);
    const initProxyVotes = (proxy) => __awaiter(void 0, void 0, void 0, function* () {
        const hiveAccounts = yield AccountUtils.getAccount(proxy);
        setVotedWitnesses(hiveAccounts[0].witness_votes);
    });
    const processClick = (witness, options) => __awaiter(void 0, void 0, void 0, function* () {
        if (activeAccount.account.witness_votes.includes(witness.owner)) {
            try {
                addToLoadingList('html_popup_unvote_witness_operation');
                const success = yield WitnessUtils.unvoteWitness(witness, activeAccount.name, activeAccount.keys.active, options);
                addToLoadingList('html_popup_confirm_transaction_operation');
                yield AsyncUtils.sleep(1000);
                removeFromLoadingList('html_popup_unvote_witness_operation');
                yield BlockchainTransactionUtils.delayRefresh();
                removeFromLoadingList('html_popup_confirm_transaction_operation');
                refreshActiveAccount();
                if (success) {
                    if (success.isUsingMultisig) {
                        setSuccessMessage('multisig_transaction_sent_to_signers');
                    }
                    else {
                        setSuccessMessage('popup_success_unvote_wit', [`${witness.owner}`]);
                    }
                }
                else {
                    setErrorMessage('popup_error_unvote_wit', [`${witness.owner}`]);
                }
            }
            catch (err) {
                setErrorMessage(err.message);
            }
            finally {
                removeFromLoadingList('html_popup_unvote_witness_operation');
                removeFromLoadingList('html_popup_confirm_transaction_operation');
            }
        }
        else {
            try {
                addToLoadingList('html_popup_vote_witness_operation');
                const success = yield WitnessUtils.voteWitness(witness, activeAccount.name, activeAccount.keys.active, options);
                addToLoadingList('html_popup_confirm_transaction_operation');
                yield AsyncUtils.sleep(1000);
                removeFromLoadingList('html_popup_vote_witness_operation');
                yield BlockchainTransactionUtils.delayRefresh();
                removeFromLoadingList('html_popup_confirm_transaction_operation');
                refreshActiveAccount();
                if (success) {
                    if (success.isUsingMultisig) {
                        setSuccessMessage('multisig_transaction_sent_to_signers');
                    }
                    else {
                        setSuccessMessage('popup_success_wit', [`${witness.owner}`]);
                    }
                }
                else {
                    setErrorMessage('popup_error_wit', [`${witness.owner}`]);
                }
            }
            catch (err) {
                setErrorMessage(err.message);
            }
            finally {
                removeFromLoadingList('html_popup_vote_witness_operation');
                removeFromLoadingList('html_popup_confirm_transaction_operation');
            }
        }
    });
    const handleVotedButtonClick = (witness) => __awaiter(void 0, void 0, void 0, function* () {
        if (usingProxy) {
            return;
        }
        if (keyType === PrivateKeyType.MULTISIG) {
            const twoFaAccounts = yield MultisigUtils.get2FAAccounts(activeAccount.account, KeychainKeyTypes.active);
            let initialMetadata = {};
            for (const account of twoFaAccounts) {
                if (!initialMetadata.twoFACodes)
                    initialMetadata.twoFACodes = {};
                initialMetadata.twoFACodes[account] = '';
            }
            if (twoFaAccounts.length > 0) {
                openModal({
                    title: 'popup_html_transaction_metadata',
                    children: (React.createElement(MetadataPopup, { initialMetadata: initialMetadata, onSubmit: (metadata) => {
                            addCaptionToLoading('multisig_transmitting_to_2fa');
                            processClick(witness, { metaData: metadata });
                            closeModal();
                        }, onCancel: () => closeModal() })),
                });
            }
        }
        else {
            processClick(witness);
        }
    });
    const renderWitnessItem = (witness, idx) => {
        return (React.createElement("div", { "data-testid": "ranking-item", className: "ranking-item", key: idx },
            React.createElement("div", { className: "rank" },
                React.createElement("div", { className: "active-rank" },
                    witness.rank ? witness.rank : '-',
                    ' ')),
            React.createElement("div", { className: 'name ' +
                    (witness.signing_key ===
                        'STM1111111111111111111111111111111114T1Anm'
                        ? 'not-active'
                        : '') },
                React.createElement("img", { className: "witness-image", src: `https://steemitimages.com/u/${witness.owner}/avatar`, onError: (e) => {
                        e.target.onError = null;
                        e.target.src = '/assets/images/accounts.png';
                    } }),
                React.createElement("div", { className: "witness-name" },
                    "@",
                    witness.owner),
                witness.url && ValidUrl.isWebUri(witness.url) && (React.createElement(SVGIcon, { dataTestId: `link-to-witness-page-${witness.owner}`, onClick: () => chrome.tabs.create({ url: replaceOldDomains(witness.url) }), icon: SVGIcons.GOVERNANCE_WITNESS_LINK, className: "link-to-witness-page" }))),
            React.createElement(SVGIcon, { dataTestId: `witness-voting-icon-${witness.owner}`, className: 'action ' +
                    (votedWitnesses.includes(witness.owner) ? 'voted' : 'not-voted') +
                    ' ' +
                    (usingProxy || !activeAccount.keys.active
                        ? 'using-proxy-button'
                        : ''), icon: SVGIcons.GOVERNANCE_WITNESS_UPVOTE_DOWNVOTE, onClick: () => handleVotedButtonClick(witness), tooltipPosition: "left", tooltipMessage: !activeAccount.keys.active
                    ? 'popup_witness_key'
                    : usingProxy
                        ? 'html_popup_witness_vote_error_proxy'
                        : undefined })));
    };
    return (React.createElement("div", { "data-testid": "witness-tab", className: "witness-tab" },
        !usingProxy && (React.createElement("div", { className: "remaining-votes" }, getMessage('popup_html_witness_remaining', [
            remainingVotes + '',
        ]))),
        usingProxy && (React.createElement("div", { className: "using-proxy" }, getMessage('html_popup_currently_using_proxy', [
            activeAccount.account.proxy,
        ]))),
        React.createElement("div", { "data-testid": "link-to-arcange", onClick: () => chrome.tabs.create({
                url: 'https://steempro.com/witnesses#time.foundation',
            }), className: "link-to-arcange" },
            React.createElement("div", null, getMessage('html_popup_link_to_witness_website'))),
        !hasError && (React.createElement("div", { className: "ranking-container" },
            React.createElement("div", { className: "ranking-filter" },
                React.createElement(InputComponent, { dataTestId: "input-ranking-filter", type: InputType.TEXT, logo: SVGIcons.INPUT_SEARCH, logoPosition: "left", placeholder: "popup_html_search", value: filterValue, onChange: setFilterValue }),
                React.createElement("div", { className: "switches-panel" },
                    React.createElement(CheckboxPanelComponent, { dataTestId: "switches-panel-witness-voted_only", title: "html_popup_witness_display_voted_only", checked: displayVotedOnly, onChange: () => {
                            setDisplayVotedOnly(!displayVotedOnly);
                        } }),
                    React.createElement(CheckboxPanelComponent, { dataTestId: "switches-panel-witness-hide_inactive", title: "html_popup_witness_hide_inactive", checked: hideNonActive, onChange: () => {
                            setHideNonActive(!hideNonActive);
                        } }))),
            React.createElement("div", { "aria-label": "ranking", className: "ranking" },
                React.createElement(FlatList, { list: filteredRanking, renderItem: renderWitnessItem, renderOnScroll: true })))),
        hasError && (React.createElement("div", { className: "error-witness" },
            React.createElement(SVGIcon, { icon: SVGIcons.MESSAGE_ERROR }),
            React.createElement("div", { className: "text" },
                React.createElement("div", null, getMessage('popup_html_error_retrieving_witness_ranking')))))));
};
const mapStateToProps = (state) => {
    return {
        activeAccount: state.steem.activeAccount,
    };
};
const connector = connect(mapStateToProps, {
    addToLoadingList,
    removeFromLoadingList,
    setErrorMessage,
    setSuccessMessage,
    refreshActiveAccount,
    addCaptionToLoading,
    openModal,
    closeModal,
});
export const WitnessTabComponent = connector(WitnessTab);
